import React, { useState } from "react";
import { Rating } from "react-simple-star-rating";
import useLocalStorage from "../../Hooks/useLocalStorage";
import axios from "axios";

export default function Chaud() {
	const [choice, setChoice] = useState();
	const [choice2, setChoice2] = useState();
	const [rating, setRating] = useState(0);
	const [rating2, setRating2] = useState(0);
	const [rating3, setRating3] = useState(0);
	const [rating4, setRating4] = useState(0);
	const [rating5, setRating5] = useState(0);
	const [rating6, setRating6] = useState(0);
	const [rating7, setRating7] = useState(0);
	const [rating8, setRating8] = useState(0);
	const [rating9, setRating9] = useState(0);
	const [rating10, setRating10] = useState(0);
	const [rating11, setRating11] = useState(0);
	const [rating12, setRating12] = useState(0);
	const [rating13, setRating13] = useState(0);
	const [rating14, setRating14] = useState(0);

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const userID = urlParams.get("id");
	const userName = urlParams.get("name");
	const formation = urlParams.get("formation");
	const [sent, setSent] = useLocalStorage("completedChaud", false);
	const [faibles, setFaibles] = useState("");
	const [plus, setPlus] = useState("");
	const [remarques, setRemarques] = useState("");

	var tooltipArr = [
		"Pas du tout",
		"Insuffisamment",
		"Moyennement",
		"En partie",
		"Totalement",
	];

	var tooltipArr2 = ["1 sur 5", "2 sur 5", "3 sur 5", "4 sur 5", "5 sur 5"];

	const sendForm = async e => {
		e.preventDefault();

		var avis1,
			avis2,
			avis3,
			avis4,
			avis5,
			avis6,
			avis7,
			avis8,
			avis9,
			avis10,
			avis11,
			avis12,
			avis13,
			avis14;

		if (rating === 20) {
			avis1 = "Pas du tout";
		}

		if (rating === 40) {
			avis1 = "Insuffisamment";
		}

		if (rating === 60) {
			avis1 = "Moyennement";
		}

		if (rating === 80) {
			avis1 = "En partie";
		}

		if (rating === 100) {
			avis1 = "Totalement";
		}

		if (rating2 === 20) {
			avis2 = "Pas du tout";
		}

		if (rating2 === 40) {
			avis2 = "Insuffisamment";
		}

		if (rating2 === 60) {
			avis2 = "Moyennement";
		}

		if (rating2 === 80) {
			avis2 = "En partie";
		}

		if (rating2 === 100) {
			avis2 = "Totalement";
		}

		if (rating3 === 20) {
			avis3 = "Pas du tout";
		}

		if (rating3 === 40) {
			avis3 = "Insuffisamment";
		}

		if (rating3 === 60) {
			avis3 = "Moyennement";
		}

		if (rating3 === 80) {
			avis3 = "En partie";
		}

		if (rating3 === 100) {
			avis3 = "Totalement";
		}

		if (rating4 === 20) {
			avis4 = "Pas du tout";
		}

		if (rating4 === 40) {
			avis4 = "Insuffisamment";
		}

		if (rating4 === 60) {
			avis4 = "Moyennement";
		}

		if (rating4 === 80) {
			avis4 = "En partie";
		}

		if (rating4 === 100) {
			avis4 = "Totalement";
		}

		if (rating5 === 20) {
			avis5 = "Pas du tout";
		}

		if (rating5 === 40) {
			avis5 = "Insuffisamment";
		}

		if (rating5 === 60) {
			avis5 = "Moyennement";
		}

		if (rating5 === 80) {
			avis5 = "En partie";
		}

		if (rating5 === 100) {
			avis5 = "Totalement";
		}

		if (rating6 === 20) {
			avis6 = "Pas du tout";
		}

		if (rating6 === 40) {
			avis6 = "Insuffisamment";
		}

		if (rating6 === 60) {
			avis6 = "Moyennement";
		}

		if (rating6 === 80) {
			avis6 = "En partie";
		}

		if (rating6 === 100) {
			avis6 = "Totalement";
		}

		if (rating7 === 20) {
			avis7 = "Pas du tout";
		}

		if (rating7 === 40) {
			avis7 = "Insuffisamment";
		}

		if (rating7 === 60) {
			avis7 = "Moyennement";
		}

		if (rating7 === 80) {
			avis7 = "En partie";
		}

		if (rating7 === 100) {
			avis7 = "Totalement";
		}

		if (rating8 === 20) {
			avis8 = "Pas du tout";
		}

		if (rating8 === 40) {
			avis8 = "Insuffisamment";
		}

		if (rating8 === 60) {
			avis8 = "Moyennement";
		}

		if (rating8 === 80) {
			avis8 = "En partie";
		}

		if (rating8 === 100) {
			avis8 = "Totalement";
		}

		if (rating9 === 20) {
			avis9 = "Pas du tout";
		}

		if (rating9 === 40) {
			avis9 = "Insuffisamment";
		}

		if (rating9 === 60) {
			avis9 = "Moyennement";
		}

		if (rating9 === 80) {
			avis9 = "En partie";
		}

		if (rating9 === 100) {
			avis9 = "Totalement";
		}

		if (rating10 === 20) {
			avis10 = "Pas du tout";
		}

		if (rating10 === 40) {
			avis10 = "Insuffisamment";
		}

		if (rating10 === 60) {
			avis10 = "Moyennement";
		}

		if (rating10 === 80) {
			avis10 = "En partie";
		}

		if (rating10 === 100) {
			avis10 = "Totalement";
		}

		if (rating11 === 20) {
			avis11 = "Pas du tout";
		}

		if (rating11 === 40) {
			avis11 = "Insuffisamment";
		}

		if (rating11 === 60) {
			avis11 = "Moyennement";
		}

		if (rating11 === 80) {
			avis11 = "En partie";
		}

		if (rating11 === 100) {
			avis11 = "Totalement";
		}

		if (rating12 === 20) {
			avis12 = "Pas du tout";
		}

		if (rating12 === 40) {
			avis12 = "Insuffisamment";
		}

		if (rating12 === 60) {
			avis12 = "Moyennement";
		}

		if (rating12 === 80) {
			avis12 = "En partie";
		}

		if (rating12 === 100) {
			avis12 = "Totalement";
		}

		if (rating13 === 20) {
			avis13 = "Pas du tout";
		}

		if (rating13 === 40) {
			avis13 = "Insuffisamment";
		}

		if (rating13 === 60) {
			avis13 = "Moyennement";
		}

		if (rating13 === 80) {
			avis13 = "En partie";
		}

		if (rating13 === 100) {
			avis13 = "Totalement";
		}

		if (rating14 === 20) {
			avis14 = "1 sur 5";
		}

		if (rating14 === 40) {
			avis14 = "2 sur 5";
		}

		if (rating14 === 60) {
			avis14 = "3 sur 5";
		}

		if (rating14 === 80) {
			avis14 = "4 sur 5";
		}

		if (rating14 === 100) {
			avis14 = "5 sur 5";
		}

		try {
			axios.post("https://global-academie.herokuapp.com/avis/chaud", {
				userID,
				userName,
				formation,
				clairete: avis1,
				discussion: avis2,
				organisation: avis3,
				stage: avis4,
				formateur: avis5,
				pertinents: avis6,
				stagiaires: avis7,
				groupe: avis8,
				choice,
				programmeClair: avis9,
				programmeAdapte: avis10,
				supportClair: avis11,
				competencesAmeliores: avis12,
				competencesAppliques: avis13,
				choice2,
				plus,
				faibles,
				note: avis14,
				remarques,
			});
			setSent(true);
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="flex min-h-screen w-full flex-col items-center justify-center">
			<form
				onSubmit={sendForm}
				className="my-16 flex w-1/2 flex-col items-center justify-center space-y-7"
			>
				<h2 className="flex w-full items-center justify-between text-3xl font-bold text-indigo-500">
					Satisfaction de votre formation
				</h2>
				<hr className="my-4 h-[3px] w-[100px] self-start border-none bg-indigo-200" />
				<div
					className={
						sent
							? "hidden"
							: "flex w-full flex-col items-center justify-center space-y-7"
					}
				>
					<h3 className="self-start text-2xl font-semibold underline">
						Préparation de la formation
					</h3>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Le programme et les objectifs de la formation
							ont-ils été clairement annoncés ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating(rate)}
								ratingValue={rating}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Avez-vous eu une discussion avec votre hiérarchie
							concernant cette formation ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating2(rate)}
								ratingValue={rating2}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<h3 className="self-start text-2xl font-semibold underline">
						Organisation de la formation
					</h3>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Etes-vous satisfait de l'organisation du transport
							et de l'hébergement ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating3(rate)}
								ratingValue={rating3}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							La durée du stage vous a-t-elle semblée adaptée ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating4(rate)}
								ratingValue={rating4}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<h3 className="self-start text-2xl font-semibold underline">
						Déroulement de la formation
					</h3>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Le formateur était-il clair et dynamique ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating5(rate)}
								ratingValue={rating5}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Les exercices et activités étaient-ils pertinents ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating6(rate)}
								ratingValue={rating6}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Le formateur a t-il adapté la formation aux
							stagiaires ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating7(rate)}
								ratingValue={rating7}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Le groupe était composé de manière adapté ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating8(rate)}
								ratingValue={rating8}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>

					<div className="w-full">
						<label
							className="mt-2 pl-1 text-2xl font-semibold underline dark:text-indigo-200"
							htmlFor="contrat"
						>
							Le rythme de la formation était...
						</label>
						<div className="my-8 flex w-full items-center space-x-6">
							<button
								type="button"
								onClick={() => setChoice("Adapté")}
								className={
									choice === "Adapté"
										? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Adapté
							</button>
							<button
								type="button"
								onClick={() => setChoice("Trop rapide")}
								className={
									choice === "Trop rapide"
										? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Trop rapide
							</button>
							<button
								type="button"
								onClick={() => setChoice("Trop lent")}
								className={
									choice === "Trop lent"
										? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Trop lent
							</button>
						</div>
					</div>

					<h3 className="self-start text-2xl font-semibold underline">
						Contenu de la formation
					</h3>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Le programme était-il clair et précis ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating9(rate)}
								ratingValue={rating9}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Le programme était-il adapté à vos besoins ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating10(rate)}
								ratingValue={rating10}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Les supports de formation étaient-ils clairs et
							utiles ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating11(rate)}
								ratingValue={rating11}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>

					<h3 className="self-start text-2xl font-semibold underline">
						Efficacité de la formation
					</h3>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Cette formation améliore t-elle vos compétences ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating12(rate)}
								ratingValue={rating12}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Ces nouvelles compétences vont-elles être
							applicables dans votre travail ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating13(rate)}
								ratingValue={rating13}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>

					<div className="w-full">
						<label
							className="mt-2 pl-1 text-2xl font-semibold underline dark:text-indigo-200"
							htmlFor="contrat"
						>
							Recommanderiez vous cette formation ?
						</label>
						<div className="my-8 flex w-full items-center space-x-6">
							<button
								type="button"
								onClick={() => setChoice2("Oui")}
								className={
									choice2 === "Oui"
										? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Oui
							</button>
							<button
								type="button"
								onClick={() => setChoice2("Non")}
								className={
									choice2 === "Non"
										? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
										: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
								}
							>
								Non
							</button>
						</div>
					</div>

					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="plus"
						>
							Quels sont les points forts de cette formation ?
						</label>
						<textarea
							value={plus}
							onChange={e => setPlus(e.target.value)}
							name="plus"
							id="plus"
							placeholder="Points forts de cette formation"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="faibles"
						>
							Quels sont les points faibles de cette formation ?
						</label>
						<textarea
							value={faibles}
							onChange={e => setFaibles(e.target.value)}
							name="faibles"
							id="faibles"
							placeholder="Points faibles de cette formation"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>

					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor=""
						>
							Note générale de la formation ?
						</label>
						<div className="mt-3 flex items-center">
							<Rating
								showTooltip={true}
								transition={true}
								tooltipArray={tooltipArr2}
								tooltipDefaultText="Votre réponse"
								onClick={rate => setRating14(rate)}
								ratingValue={rating14}
								fillColorArray={[
									"#f17a45",
									"#f19745",
									"#f1a545",
									"#f1b345",
									"#f1d045",
								]}
							/>
						</div>
					</div>
					<div className="w-full">
						<label
							className="pl-1 font-medium dark:text-indigo-200"
							htmlFor="remarques"
						>
							Autres remarques
						</label>
						<textarea
							value={remarques}
							onChange={e => setRemarques(e.target.value)}
							name="remarques"
							id="remarques"
							placeholder="Autres remarques"
							className="mt-1 max-h-[250px] min-h-[150px] w-full rounded-md border border-gray-400/50 bg-white p-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
						/>
					</div>
					<button
						type="submit"
						className="w-full rounded-md border-2 border-transparent bg-indigo-500 p-3 font-medium text-white transition-all duration-200 hover:border-indigo-500 hover:bg-transparent hover:text-indigo-500"
					>
						Envoyer
					</button>
				</div>
				<div
					className={
						sent
							? "visible-check flex h-[250px] flex-col items-center justify-center opacity-100 transition-all duration-300 ease-in-out"
							: "flex h-[0px] flex-col items-center justify-center overflow-hidden opacity-0 transition-all duration-300 ease-in-out"
					}
				>
					<svg
						className="checkmark"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 52 52"
					>
						<circle
							className="checkmark__circle"
							cx="26"
							cy="26"
							r="25"
							fill="none"
						/>
						<path
							className="checkmark__check"
							fill="none"
							d="M14.1 27.2l7.1 7.2 16.7-16.8"
						/>
					</svg>
					<h4 className="my-7 text-2xl font-medium">
						Merci pour vos réponses!
					</h4>
				</div>
			</form>
		</div>
	);
}
